export const themeColors = {
    textColor: "#00385F",
    george_text_color: "#0a285c",

    georgeBlue: "#135ee2",
    georgeBlue_surface: "#2870ed",
    blue_200: "#96C2EA",
    blue_300: "#1d69ec",
    blue_400: "#21416c",
    d_blue_100: "#398bfc",
    d_blue_200: "#1c457d",
    d_grey_100: "#8e8e93",
    d_grey_200: "#3a3a3c",
    d_grey_300: "#1c1c1e",
    grey_100: "#f4f6fa",
    grey_200: "#e4eaf0",
    grey_300: "#a3b5c9",
    grey_400: "#5c7999",
    ui_blue: "#199CF9",
    ui_blue_light: "#f3faff",
    ui_green: "#00ab56",
    ui_red: "#f94242",
    ui_yellow: "#F2A91E",
    ui_violet: "#2C2A88",
    ui_lila: "#721c7a",
    ui_lavender: "#aa4bb3",
    ui_indigo: "#2f2d91",
    ui_pool: "#199cf9",
    ui_lila_light: "#f7f3f8",
    ui_red_medium: "#e1015b",
    ui_red_light: "#fdf2f7",
    ui_green_medium: "#209474",
    ui_green_light: "#f2f9f7",

    backgroundColorDark: "#14141A",
};

export const MAX_APP_WIDTH = 800;

export const HEADER_ICON_SIZE = 146;
export const HEADER_HEIGHT = 190;
export const ACTION_BUTTON_HEIGHT = 56;
export const ACTION_BUTTON_HEIGHT_INLINE = 50;
export const NAVBAR_HEIGHT = 60;
export const HEADER_CONTENT_SPACING = NAVBAR_HEIGHT;
export const WEB_HEADER_HEIGHT = 66;

export const BORDER_RADIUS = 4;
export const BORDER_RADIUS_LARGE = 12;
export const BORDER_RADIUS_FULL = 50;

export const MARGIN_TINY = 4;
export const MARGIN_SMALL = 10;
export const MARGIN_MEDIUM = 16;
export const MARGIN = 20;
export const MARGIN_LARGE = 32;
export const MARGIN_XLARGE = 40;
export const MARGIN_XXLARGE = 48;

export const Z_INDEX_DEBUG_OVERLAY = 100;

export const customColors = {
    georgeBlue: "#0967AB",
    georgeLightBlue: "#00a8ff",
    georgeBabyBlue: "#d9edf7",

    georgeLightGrey: "#95A8B6",

    georgeGradient2: "#03A5FF",
    georgeInputFrame: "#B8C4D1",
    georgeclientBackground: "#e7ebef",
    silver: "#eee",
    storeGradientDarkBlue: "#00497B",
    storeGradientLightBlue: "#BCE4FA",

    georgeOrange: "#FF5127",

    georgeJuniorBackground: "#EEF0F4",
    georgeJuniorSecondary: "#537091",
};

export const focusShadow = `0 0 0 4px #d2dbe2`;
export function headerBackgroundColor(isDarkMode: boolean) {
    return isDarkMode ? themeColors.d_blue_200 : themeColors.blue_300;
}




// WEBPACK FOOTER //
// ./src/muiTheme.ts